import { RestoreNoTransactionError } from '@forest/paywall-core'
import { isHTTPError } from 'ky'
import { isConnectivityError } from '~/lib/is-connectivity-error'

type Platform = 'ios' | 'googleplay_android' | 'china_android'

export type RestoreErrorBranch =
  | { kind: 'no_transaction'; intercomNode: 'restore_no_transaction' }
  | { kind: 'owner_uid_conflict'; status: 409 | 412 }
  | { kind: 'forest_account_mismatch' }
  | { kind: 'transaction_expired' }
  | {
      kind: 'unexpected_http'
      status: number
      intercomNode: 'restore_purchase_unexpected_http_error'
    }
  | { kind: 'connection' }
  | { kind: 'unexpected'; intercomNode: 'restore_purchase_unexpected_error' }

export function classifyRestoreError(
  error: unknown,
  platform: Platform,
): RestoreErrorBranch {
  if (error instanceof RestoreNoTransactionError) {
    return { kind: 'no_transaction', intercomNode: 'restore_no_transaction' }
  }
  if (isHTTPError(error)) {
    const status = error.response.status
    if ((status === 409 || status === 412) && platform !== 'china_android') {
      return { kind: 'owner_uid_conflict', status }
    }
    if (status === 403 && platform !== 'china_android') {
      return { kind: 'forest_account_mismatch' }
    }
    if (
      status === 410 ||
      ((status === 403 || status === 409) && platform === 'china_android')
    ) {
      return { kind: 'transaction_expired' }
    }
    return {
      kind: 'unexpected_http',
      status,
      intercomNode: 'restore_purchase_unexpected_http_error',
    }
  }
  if (isConnectivityError(error)) {
    return { kind: 'connection' }
  }
  return {
    kind: 'unexpected',
    intercomNode: 'restore_purchase_unexpected_error',
  }
}
